<template>
  <div class='image-header-container'>
    <t-header :class='{fixed: fixedHeader}'/>
    <div class='top-container'>
    </div>
    <div class='bc'>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class='link' @click.native='handleBack'>新闻中心</el-breadcrumb-item>
        <el-breadcrumb-item class='blue'>{{data.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <article class='artical-content'>
      <div class="ql-container ql-snow">
        <div class="ql-editor" v-html='data.content'>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import THeader from '../../components/header';
import imageHeaderMixin from '../../mixins/imageHeader';
import axios from 'axios';

export default {
  metaInfo() {
    return {
      title: this.data.title,
      meta: [
        {
          name: 'keywords',
          content: this.data.keywords,
        },
        {
          name: 'description',
          content: this.data.abstractMemo,
        },
      ]
    }
  },
  components: {
    THeader,
  },
  mixins: [imageHeaderMixin],
  data() {
    return {
      data: {
        title: '',
        keywords: '',
        abstractMemo: '',
      },
    }
  },
  mounted() {
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      axios.post('/api/portal/info/view', {
        id: this.$route.params.id,
      }).then(res => {
        const { code, data, flag } = res.data;
        if (code === 0 && flag === 0) {
          this.data = data || {};
          this.$set(this.data, 'content', `<h2 class='ql-align-center' style='margin-bottom: 20px;'>${this.data.title}</h2>${this.data.content}`)
        } else {
          this.data = {};
        }
      })
    },
    handleBack() {
      this.redirect("/news?p=1");
    }
  }
}
</script>

<style lang="less" scoped>
.bc {
  width: 950px;
  margin: 0 auto;
  padding: 30px 0;
  /deep/ .el-breadcrumb__inner {
    font-size: 16px;
    color: #999;
  }
  /deep/ .blue .el-breadcrumb__inner {
    color: #718EFF;
  }
  /deep/ .link .el-breadcrumb__inner {
    cursor: pointer;
  }
}
.artical-content {
  width: 950px;
  margin: 0 auto;
  padding-bottom: 30px;
  min-height: 300px;
}
</style>